import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsCustomerAccessRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-customer-access',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/customer-access',
};
